import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { AlertpopupService } from '../../services/alertpopup.service';

@Component({
  selector: 'app-alert-popup',
  imports: [DialogModule,CommonModule],
  templateUrl: './alert-popup.component.html',
  styleUrl: './alert-popup.component.scss'
})
export class AlertPopupComponent {
  public alertContent:any;
  visible:any=false;
  constructor(private _alertservice:AlertpopupService) { }
  ngOnInit(){
   this._alertservice.getAlertPopup().subscribe((alertdata)=>{
    this.alertContent=alertdata;
    if(this.alertContent.message){
      this.visible=true;
    }
   })

  }

}
